import NotificationManager from '../../components/common/react-notifications/NotificationManager'

export const REWARDS_LOADING = 'REWARDS_LOADING'

export const setLoadingRewardsAction = (loading) => (dispatch,) => dispatch({
	type: REWARDS_LOADING,
	loading,
},)

export const rewardsCreateAction = (action, variables,) => async (dispatch,) => {
	try {
		dispatch(setLoadingRewardsAction(true))
		const { data, } = await action({ variables, })
		dispatch(setLoadingRewardsAction(false))
		return data.rewards.id
	} catch (e) {
		NotificationManager.error(
			e.message || '',
			'Проблема создания',
			3000,
			null,
			null,
		)
		dispatch(setLoadingRewardsAction(false))
		return null
	}
}

export const rewardsUpdateAction = (action, variables,) => async (dispatch,) => {
	try {
		dispatch(setLoadingRewardsAction(true))
		const { data, } = await action({ variables, })
		return data.rewards
	} catch (e) {
		NotificationManager.error(
			e.message || '',
			'Проблема Обновления',
			3000,
			null,
			null,
		)
		dispatch(setLoadingRewardsAction(false))
	}
	dispatch(setLoadingRewardsAction(false))
}
